import * as Lazy from './toolsRoutes.lazy';

/**
 * Tools routes with lazy loading
 */
const toolsRoutes = [
  { path: '/tools', renderer: () => <Lazy.ToolsHub /> },
  { path: '/tools/ev-calculator', renderer: () => <Lazy.EvCalculator /> },
  { path: '/tools/kelly-calculator', renderer: () => <Lazy.KellyCalculator /> },
  { path: '/tools/parlay-calculator', renderer: () => <Lazy.ParlayCalculator /> },
  { path: '/tools/odds-converter', renderer: () => <Lazy.OddsConverter /> },
  { path: '/tools/implied-probability-calculator', renderer: () => <Lazy.ImpliedProbabilityCalculator /> },
  { path: '/tools/hedge-calculator', renderer: () => <Lazy.HedgeCalculator /> },
  { path: '/tools/vig-calculator', renderer: () => <Lazy.VigCalculator /> },
];

export default toolsRoutes;
